import React from 'react';
import {Layout} from '..';
import {ThemeColorName} from '../../theme';
import {RadioKind, RadioProps} from './types';
export const Radio: React.FC<RadioProps> = ({
  checked,
  kind = 'Default',
  onPress,
}) => {
  return (
    <Layout
      centered
      onPress={onPress}
      width={24}
      height={24}
      borderRadius={'9999'}
      borderWidth="1"
      borderColor={styleMap[kind].borderColor}
      backgroundColor={
        checked ? styleMap[kind].backgroundColor : 'background_mono_primary'
      }
      borderStyle="solid">
      {checked && (
        <Layout
          centered
          height={6}
          width={6}
          borderRadius="9999"
          backgroundColor={'background_mono_primary'}
        />
      )}
    </Layout>
  );
};

const styleMap: {
  [key in RadioKind]: {
    backgroundColor: ThemeColorName;
    borderColor: ThemeColorName;
  };
} = {
  Default: {
    backgroundColor: 'background_mono_inverse_primary',
    borderColor: 'border_mono_30',
  },
  Success: {
    backgroundColor: 'background_positive_default',
    borderColor: 'border_positive_default',
  },
  Error: {
    backgroundColor: 'background_negative_default',
    borderColor: 'border_negative_default',
  },
  Disabled: {
    backgroundColor: 'background_mono_inverse_disabled',
    borderColor: 'border_mono_15',
  },
};
